import { ElementType, IElement } from '../../../models/Element';

export type PluginRightScreenshotInfoNoButtons = IElement & {
  title: string;
  description: string;
  image_preview: string;
  image_preview_alt: string;
};

export const defaultPluginRightScreenshotInfoNoButtons: PluginRightScreenshotInfoNoButtons =
  {
    id: 0,
    name: ElementType.PLUGIN_RIGHT_SCREENSHOT_INFO_NO_BUTTONS,
    title: 'Zoekmachine vriendelijk',
    description:
      'Het CRM-pakket van Realworks is bij uitstek geschikt voor het beheren van objecten, projecten en woningen. De WordPress Makelaars plugin maakt een ijzersterke combinatie.',
    image_preview: '',
    image_preview_alt: '',
  };
